export const URL_PRIVACY_POLICY = "https://hallow.com/privacy-policy";
